import { decorate } from './decorate';

export function promiseDecoratorQ($provide) {
  'ngInject';
  $provide.decorator('$q', ($delegate) => {
    // Extend promises
    let defer = $delegate.defer,
      when = $delegate.when,
      resolve = $delegate.resolve,
      reject = $delegate.reject,
      all = $delegate.all;

    $delegate.defer = function deferDelegate() {
      let deferred = defer();
      decorate(deferred.promise);
      return deferred;
    };
    $delegate.when = function whenDelegate() {
      let p = when.apply(this, arguments);
      return decorate(p);
    };
    $delegate.resolve = function resolveDelegate() {
      let p = resolve.apply(this, arguments);
      return decorate(p);
    };
    $delegate.reject = function rejectDelegate() {
      let p = reject.apply(this, arguments);
      return decorate(p);
    };
    $delegate.all = function allDelegate() {
      let p = all.apply(this, arguments);
      return decorate(p);
    };

    return $delegate;
  });
}
